
"use client";
import { compareDate, dateFormat, formattedDate, toDate } from "./DayJS";
import { createTheme } from "@mui/material";
import { LANGCODE_EN, LANGTYPE_EN, LANGCODE_CT } from "./LanguageContext";
import { useSearchParams } from "next/navigation";

export const convertWindDirection = (input) => {
  //input "N" or "W" or "E" or "S"  single direction 
  if (/^[NSEW]$/.test(input)) return input;

  //input "NE" or "SW" double direction
  const doubleDirections = {
    "NE": "NE", "EN": "NE", "SE": "SE", "ES": "SE",
    "SW": "SW", "WS": "SW", "NW": "NW", "WN": "NW"
  };
  if (input in doubleDirections) return doubleDirections[input];

  //input "S17E"  format (mainDir + offset + subDir)
  const regex = /^([NS])(\d+)[°]?([EW])$/;
  if (!regex.test(input)) {
    console.error('Invalid input format. Expected "N17E" or "S17°E"');
    return null;
  }
  const [, mainDir, offsetStr, subDir] = input.match(regex);
  const offset = parseInt(offsetStr);
  const baseAngles = { N: 0, E: 90, S: 180, W: 270 };
  let finalAngle = baseAngles[mainDir];
  if (mainDir === 'N') {
    finalAngle += (subDir === 'E') ? offset : -offset;
  } else if (mainDir === 'S') {
    finalAngle += (subDir === 'W') ? offset : -offset;
  }
  finalAngle = (finalAngle + 360) % 360;
  const directions = [
    "N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE",
    "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"
  ];
  const index = Math.floor((finalAngle + 11.25) / 22.5) % 16;
  return directions[index];
}
export const STDirections = (direction) => {
  let result = 0
  switch (direction) {
    case "N":
      result = 49;
      break
    case "NNE":
      result = 71.5;
      break
    case "NE":
      result = 94;
      break
    case "ENE":
      result = 116.5;
      break
    case "E":
      result = 139;
      break
    case "ESE":
      result = 141.5;
      break
    case "SE":
      result = 184;
      break
    case "SSE":
      result = 206.5;
      break
    case "S":
      result = 229;
      break
    case "SSW":
      result = 251.5;
      break
    case "SW":
      result = 274;
      break
    case "WSW":
      result = 296.5;
      break
    case "W":
      result = 319;
      break
    case "WNW":
      result = 341.5;
      break
    case "NW":
      result = 4;
      break
    case "NNW":
      result = 26.5;
      break
    default:
      result = 0;
      break
  }
  return result;
};
export const HVDirections = (direction) => {
  let result = 0;
  switch (direction) {
    case "N":
      result = 116;
      break;
    case "NNE":
      result = 138.5;
      break;
    case "NE":
      result = 171;
      break;
    case "ENE":
      result = 183.5;
      break;
    case "E":
      result = 206;
      break;
    case "ESE":
      result = 228.5;
      break;
    case "SE":
      result = 251;
      break;
    case "SSE":
      result = 273.5;
      break;
    case "S":
      result = 296;
      break;
    case "SSW":
      result = 318.5;
      break;
    case "SW":
      result = -19;
      break;
    case "WSW":
      result = 3.5;
      break;
    case "W":
      result = 26;
      break;
    case "WNW":
      result = 48.5;
      break;
    case "NW":
      result = 71;
      break;
    case "NNW":
      result = 93.5;
      break;
    default:
      result = 0;
      break;
  }
  return result;
};
export function redirectPage(e, action, lang) {
  e.preventDefault();
  let url = "";
  if (typeof window !== "undefined" && window.top !== null) {
    let returnURL = window.top.location.href;
    if (typeof returnURL !== "undefined") {
      returnURL = encodeURIComponent(returnURL);
      if (lang === LANGCODE_EN) {
        if (action == "login") {
          url = window.globalConfig?.LINKED_PAGES?.LOGINPAGE + "Lang=E&ReturnUrl=" + returnURL;
          window.top.location.href = url;
        } else if (action == "logout") {
          alert("If you are using HKJC Web Services in other browser windows, they will also be logged out. Please close those browser windows if needed.");
          url = window.globalConfig?.LINKED_PAGES?.LOGOUTPAGE + "&Lang=E&ReturnUrl=" + returnURL;
          window.top.location.href = url;
        } else if (action == "register") {
          url = window.globalConfig?.LINKED_PAGES?.REGISTERPAGE + "&Lang=E";
          window.top.location.href = url;
        } else if (action == "preference") {
          url = window.globalConfig?.LINKED_PAGES?.PREFERENCEPAGE + "&Lang=E&ReturnUrl=" + returnURL;
          window.top.location.href = url;
        } else if (action == "help") {
          window.open(window.globalConfig?.LINKED_PAGES?.FAQPAGEENG);
        }
      } else {
        if (action == "login") {
          url = window.globalConfig?.LINKED_PAGES?.LOGINPAGE + "Lang=C&ReturnUrl=" + returnURL;
          window.top.location.href = url;
        } else if (action == "logout") {
          alert("如你正在其他視窗開啟馬會網上服務，該等服務亦會同時被登出，如有需要請關閉該等視窗。");
          url = window.globalConfig?.LINKED_PAGES?.LOGOUTPAGE + "&Lang=C&ReturnUrl=" + returnURL;
          window.top.location.href = url;
        } else if (action == "register") {
          url = window.globalConfig?.LINKED_PAGES?.REGISTERPAGE + "&Lang=C";
          window.top.location.href = url;
        } else if (action == "preference") {
          url = window.globalConfig?.LINKED_PAGES?.PREFERENCEPAGE + "&Lang=C&ReturnUrl=" + returnURL;
          window.top.location.href = url;
        } else if (action == "help") {
          window.open(window.globalConfig?.LINKED_PAGES?.FAQPAGECHI);
        }
      }
    }
  }
}
export const theme = createTheme({
  components: {
    // Name of the component
    MuiButtonBase: {
      defaultProps: {
        // The props to change the default for.
        disableRipple: true, // No more ripple, on the whole application 💣!
      },
    },
    MuiLink: {
      defaultProps: {
        underline: "hover",
        color: "#122C68"
      }
    }
  },
  typography: {
    fontFamily: "inherit",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 900,
      lg: 1024,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: "#173E96",
      light: "#E2EDF6",
      dark: "#132B68",
    },
    grey: {
      100: "#F4F4F4",
      300: "#E1E1E1",
    },
    text: {
      primary: "#000000",
      secondary: "#333333",
    },
    divider: "#B4B4B4",
  },
  extraPalette: {
    primary: {
      grey: "#909FBD",
      darkGrey: "#6176A0",
    },
    text: {
      primary: "#122C68",
    }
  },
});
export const getLoginInfo = (custProIn, langType) => {

  const custProInList = getCookie(custProIn)
  let isLogin = false;
  let displayName = ""
  console.log("custProIn 1", custProIn, custProInList)
  //setIsLogin(false);
  if (getLastName(custProIn) != null) {
    //setIsLogin(true);
    isLogin = true;
    displayName = langType === LANGCODE_EN ?
      showDisplayNameEN(getDisplayName(custProInList), getSalutation(custProInList), getLastName(custProInList), getLastNameChinese(custProInList)) :
      showDisplayNameCH(getDisplayName(custProInList), getSalutation(custProInList), getLastName(custProInList), getLastNameChinese(custProInList))
    //setShowDisplayName(displayName);  
  }
  return { isLogin, displayName }


  function getCookie(name) {
    // var nameEQ = name + "=";
    // var ca = document.cookie.split(';'); 
    // let d = "";
    const h = ":";
    // for (var i = 0; i < ca.length; i++) {
    //   var c = ca[i];

    //   while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    //   console.log("ssssss  2",c)
    //   if (c.indexOf(nameEQ) == 0)
    //   { console.log("ssssss  2",nameEQ.length, c.length ,  c.substring(nameEQ.length, c.length)); 
    //    d = c.substring(nameEQ.length, c.length); break}    
    // }
    // console.log("ssssss",d)
    let a = [];
    if (name != null) {
      a = name.split(h);
      return a
    }
    return [];
  }

  function E(a, n) {
    if (a?.[n] != null) {
      return decodeURIComponent(a[n].replace(/\+/g, "%20"))
    } else {
      return null
    }
  }

  function getDisplayName(a) {
    return E(a, 0)
  }
  function getSalutation(a) {
    return E(a, 1)
  }
  function getLastName(a) {
    return E(a, 2)
  }
  function getLastNameChinese(a) {
    return E(a, 3)
  }
  function showDisplayNameCH(displayname, salutation, lastname, lastnamechinese) {
    var showname = displayname;
    if (salutation == "Mr." || salutation == "Mr")
      salutation = "先生";

    if (salutation == "Ms." || salutation == "Ms")
      salutation = "女仕";

    if (salutation == "Miss." || salutation == "Miss")
      salutation = "小姐";

    if (salutation == "Mrs." || salutation == "Mrs")
      salutation = "太太";

    if (displayname == "" || displayname == null) {

      if (lastnamechinese == "" || lastnamechinese == null)
        showname = (lastname ?? "") + (salutation ?? "");
      else
        showname = lastnamechinese + salutation;
    }

    var name = "    " + showname + "    ";
    return name;
  }

  function showDisplayNameEN(displayname, salutation, lastname, lastnamechinese) {
    var showname = displayname;
    if (salutation == "先生")
      salutation = "Mr";

    if (salutation == "女士")
      salutation = "Ms";

    if (salutation == "小姐")
      salutation = "Miss";

    if (salutation == "太太")
      salutation = "Mrs";

    if (displayname == "" || displayname == null)
      showname = salutation + "." + lastname;

    var name = "    " + showname + "    ";
    return name;
  }
}
export const switchLanguage = (lang) => {
  const currentPath = window.location.pathname;
  const pathParts = currentPath.split("/");
  if ([LANGCODE_EN, LANGCODE_CT].includes(pathParts[1])) {
    pathParts[1] = lang;
    const newPath = pathParts.splice(0, 4).join("/");
    window.location.href = generateUrl(newPath, { 'b_cid': '' }, true, true, lang);
  }
};
export const openTarget = (target) => {
  return target ? (["01-NewPage", "_blank"].includes(target || '') ? "_blank" : "_self") : undefined;
};

export const openNewWindow = (newwindow) => {
  return newwindow === "1" ? "_blank" : "_self";
};
export const isBeforeCutoff = (date) => (date && date.getTime() !== 0) ? compareDate(formattedDate(date, "YYYYMMDD"), window.globalConfig?.OTHERS?.CUTOFF_DATE, "before", false) : false;
export const setRouting = (newPathname, queries, curState) => {
  const curUrl = window.location.href
  const host = window.location.host
  const newUrl = generateUrl(newPathname, queries, true);
  console.log('route generate', newUrl, queries)
  if (curUrl.slice(curUrl.indexOf(host) + host.length) != newUrl) {
    console.log('route update', curUrl, newUrl)
    window.history.pushState({ prePath: curUrl }, '', newUrl);
  }
}
/**
 * Need to set isExternal = true when not navigating within /overseas
 * Only input langCodeToChange when switching language
 * 
 * @param newPathname 
 * @param queries 
 * @param keepQuery 
 * @param isExternal 
 * @param langCodeToChange 
 * @returns 
 */
export const generateUrl = (newPathname, queries, keepQuery, isExternal = false, langCodeToChange) => {
  if (newPathname) {
    newPathname = sanitizeInput(newPathname); // Sanitize the pathname
  }

  const path = newPathname?.split("?")?.[0];
  const searchPart = newPathname?.split("?")?.[1];
  let params = new URLSearchParams(keepQuery ? window.location.search : searchPart);
  // sanitation & set param
  // For generating external url, don't apply case insensitive on url query
  const paramsObj = { ...(isExternal ? Object.fromEntries(params.entries()) : getSearchParams(params)), ...queries } // queries value will override current params if it is duplicated
  params = new URLSearchParams(paramsObj)
  for (const key in paramsObj) {
    if (paramsObj[key]) {
      params.set(key, sanitizeInput(paramsObj[key]?.toString()) || '');
    } else {
      params.delete(key);
    }
  }
  if (isExternal) {
    return decodeURIComponent(`${path || window.location.pathname}${params.toString() ? "?" + params.toString() : ''}`)
  }
  const langCode = langCodeToChange || window.location.pathname?.split("/")?.[1] || "en-us"
  return decodeURIComponent(`${path ? "/" + langCode + "/overseas" + path : window.location.pathname}${params.toString() ? "?" + params.toString() : ''}`)
}

export const redirectToLink = (link, target, features) => {
  if (!link) return;
  return window.open(link, target || "_blank", features);
};
export const isUrlExisted = async (url) => {
  let controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), window.globalConfig?.OTHERS?.CHECKEXIST_TIMEOUT || 10000);
  return !url ? false : await fetch(url, { method: "HEAD", cache: "no-store", signal: controller.signal, redirect: 'manual' })
    .then((res) => { return res.url.replace(/https:|http:/g, '') == url.replace(/https:|http:/g, '') && [200, 302].includes(res.status) })
    .catch((err) => {
      console.log('err----', err)
      return false
    });
};
export function formatDateTime(isoString) {
  const date = new Date(isoString);
  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });

  return formatter.format(date).replace(',', '');
}
export const getAssetPrefix = () => process.env.NEXT_PUBLIC_WITH_PREFIX === 'Y' ? '/local/informationAsset' : '';

export function useSearchParamsLowercase() {
  const searchParams = useSearchParams();
  const lowerCaseParams = new URLSearchParams();
  searchParams.forEach((value, key) => {
    lowerCaseParams.append(key.toLowerCase(), value);
  });
  return lowerCaseParams;
}